/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_N3Inputs */

const en_sorter_ref_n3 = /** @type {(inputs: Sorter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byte order would give zebra, école. The accent is folded to e.`)
};

const ko_sorter_ref_n3 = /** @type {(inputs: Sorter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바이트 순이라면 zebra, école이 됩니다. 악센트가 e로 접힙니다.`)
};

const ja_sorter_ref_n3 = /** @type {(inputs: Sorter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト順なら zebra, école になります。アクセントが e に畳まれます。`)
};

/**
* | output |
* | --- |
* | "Byte order would give zebra, école. The accent is folded to e." |
*
* @param {Sorter_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_n3 = /** @type {((inputs?: Sorter_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_n3(inputs)
	if (locale === "ko") return ko_sorter_ref_n3(inputs)
	return ja_sorter_ref_n3(inputs)
});